export type Trilean = 'UNKNOWN' | 'TRUE' | 'FALSE'

export function asTrilean(state: boolean | undefined): Trilean {
  return state === true ? 'TRUE' : state === false ? 'FALSE' : 'UNKNOWN'
}
